import React from 'react'
import { useTranslation } from 'react-i18next'
import { ResultsLayout } from 'components/layout/ResultsLayout'
import { useGetApplicationsQuery } from 'hooks/queries/Customers/useGetApplicationsQuery'
import { ApplicationItems } from './ApplicationItems'

export const CustomersListV2 = () => {
  const { t } = useTranslation()

  const { data, isFetching, isError, refetch } = useGetApplicationsQuery()

  const applicationsData = data || []

  return (
    <ResultsLayout
      testId="customers-v2-results"
      isLoading={isFetching}
      isError={isError}
      hasResults={!!applicationsData?.length}
      hasSearchAndFilter={false}
      refetchResults={refetch}
      header={{
        description: t('customers.descriptionV2'),
      }}
      emptyState={{
        title: t('embeddedCustomers.emptyStatus.headline'),
        description: t('embeddedCustomers.emptyStatus.descriptionAddDetails'),
      }}
    >
      <ApplicationItems applications={applicationsData} />
    </ResultsLayout>
  )
}
